<div class="form-group">
  <input type="number"
         class="form-control input"
         [ngModel]="serviceTimeInMinutes"
         (ngModelChange)="onChangeValue($event)"
         [attr.disabled]="isDisabled"
         [placeholder]="ngPlaceholder | translate">

  <div *ngIf="ngControl?.control?.invalid && ngControl?.control?.touched" class="margin-top-5">
    <p class="br-caption-1 red-103" *ngIf="ngControl.control.errors?.min">
      Minimum value is {{ minValue }}
    </p>
    <p class="br-caption-1 red-103" *ngIf="ngControl.control.errors?.required">
      Value is required
    </p>
  </div>
</div>
